import axios from 'axios';

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/licenses";

// GET
export async function getLicense(licensePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Licenses/get-license/${licensePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch license');
  }
}

export async function getLicensesByTenantId(tenantPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Licenses/get-licenses-by-tenant/${tenantPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch license');
  }
}

export async function getLicensesGroupedByTenantId(tenantPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Licenses/get-licenses-grouped-by-tenant/${tenantPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch grouped licenses');
  }
}

/**
 * PBI #300: the tenant's own licences, offered as add-ons in the onboarding form. The API
 * de-duplicates per product, so one product is returned once however many billing-group
 * rows it is split over.
 *
 * The optional chaining is deliberate: a bare network failure carries no `response`, and
 * reading it unguarded (as getLicense above still does) throws a TypeError instead of an
 * error the caller can show.
 */
export async function getAddOnLicenseOptionsByTenant(tenantPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/Licenses/get-license-options-by-tenant/${tenantPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch add-on license options"
    );
  }
}

// PUT
export async function updateLicense(
  billingGroupPublicId,
  licensePublicId,
  apiAccessToken
) {
  try {
    const requestData = {
      billingGroupPublicId,
      licensePublicId,
      updatedDateTimeUTC: new Date().toISOString(),
    };

    const response = await axios.put(
      `${baseUrl}/Licenses/update-license`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error Response:", error.response?.data);
    throw new Error(error.response?.data?.message || "Failed to update billing group on license"
    );
  }
}

// Function to delete a license by licenseId
export async function deleteLicense(licenseId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/delete-license/${licenseId}`, {
      headers: {
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete license');
  }
}

export async function upsertLicenseBillingGroup(
  licenseBillingGroupPublicId,
  licensePublicId,
  billingGroupPublicId,
  quantity,
  apiAccessToken
) {
  try {
    const requestData = {
      licenseBillingGroupPublicId,
      licensePublicId,
      billingGroupPublicId,
      quantity,
    };

    const response = await axios.put(
      `${baseUrl}/Licenses/dip/assign-license-quantity-to-billing-group`,
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Error Response:", error.response?.data);
    throw new Error(error.response?.data?.message || "Failed to assign license quantity to billing group"
    );
  }
}